/** Scaled font size — multiply a px value by the global --text-scale CSS variable. */
export const fs = (px) => `calc(${px}px * var(--text-scale, 1))`;

/** Scaled clamp() font size for responsive headings. */
export const fsClamp = (minPx, preferred, maxPx) =>
    `calc(clamp(${minPx}px, ${preferred}, ${maxPx}px) * var(--text-scale, 1))`;

/** Scaled layout dimension (heights, min-widths tied to text size). */
export const sz = (px) => `calc(${px}px * var(--text-scale, 1))`;
